export const UtmSources = {
    FreelancersUnion: 'freelancersunion',
    JohnBranch: 'johnbranch',
    PicTime: 'pictime',
    Adobe: 'adobe',
    PublicTemplate: 'publictemplate',
    BreakthroughInvite: 'breakthrough_invite',
    MspInvite: 'msp_invite',
    BreakthroughMspInvite: 'breakthrough_msp_invite',
    Prismm: 'prismm',
    Instabooked: 'instabooked_msp_invite',
    TheKnot: 'tkww',
    Zoom: 'zoom',
    ClientRelationships: 'client_relationships',
    Showit: 'showit',
    TimelineGenius: 'timeline_genius_expired',
    TimelineGeniusFlow1: 'timeline_genius_f1_expired',
    Blazeai: 'blazeai',
    Rella: 'rella',
    Weven: 'weven'
} as const;

export type TUtmSource = (typeof UtmSources)[keyof typeof UtmSources];
